/**
 * WhatsIncluded — substance panel above the scoping cards.
 *
 * Conveys what a /Recon engagement actually delivers so the buyer
 * understands what their $249+ goes toward before they start picking
 * checkboxes. Renders below the hero, above PrimaryScopeCard.
 *
 * No marketing language — facts about the deliverable. The buyer is
 * already signed in; credibility is settled. What's missing for them
 * at this point is "what am I scoping for, and what comes out at the
 * end."
 */

import "./whats-included.css";

interface IncludedItem {
  label: string;
  detail: string;
}

const ITEMS: IncludedItem[] = [
  {
    label: "Full attack-surface report",
    detail:
      "Detailed PDF — typically 45–70 pages — covering every finding, ranked by impact with concrete remediation steps.",
  },
  {
    label: "Coverage across the stack",
    detail:
      "DNS hygiene, SSL/TLS posture, email authentication, web technology fingerprinting, subdomain enumeration, port discovery, vulnerability scanning, cloud exposure, leaked credentials.",
  },
  {
    label: "Delivered in 3–5 business days",
    detail:
      "Reviewed end-to-end before delivery — no raw tool output dumped into a template. Findings get context, severity, and clear next steps.",
  },
  {
    label: "Online + PDF deliverables",
    detail:
      "The same report rendered as an interactive in-portal viewer and as a signed PDF you can forward to insurers, boards, or auditors.",
  },
];

export function WhatsIncluded() {
  return (
    <section
      className="whats-included"
      aria-labelledby="whats-included-heading"
    >
      <header className="whats-included-header">
        <div className="whats-included-eyebrow">WHAT YOU GET</div>
        <h2 id="whats-included-heading">Every engagement includes</h2>
      </header>
      <ul className="whats-included-list">
        {ITEMS.map((item, i) => (
          <li key={i} className="whats-included-item">
            <div className="whats-included-item-marker" aria-hidden="true">
              {String(i + 1).padStart(2, "0")}
            </div>
            <div className="whats-included-item-body">
              <div className="whats-included-item-label">{item.label}</div>
              <div className="whats-included-item-detail">{item.detail}</div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
